import { searchQuery } from "constants/queries";
import { debounce } from "helpers/debounce";
import client from "helpers/sanity";
import React from "react";
import { useCallback } from "react";
import { memo } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { FaSearch } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";

const SearchBar = ({ handleResult }) => {
  const [query, setQuery] = useState("");

  const debouncedSearch = useCallback(debounce(handleSearch, 500), []); //eslint-disable-line

  useEffect(() => {
    if (query === "") handleResult([]);
    debouncedSearch(query);
  }, [query, handleResult, debouncedSearch]);

  async function handleSearch(query) {
    if (query.length <= 3) return;

    try {
      const data = await client.fetch(searchQuery, {
        query: `${query}*`,
      });
      handleResult(data || []);
    } catch (err) {
      console.error("Error fetching search results:", err);
    }
  }

  async function handleClear() {
    setQuery("");
    handleResult([]);
  }

  return (
    <div className="w-full mt-2 sm:mt-4 md:mt-6 bg-white flex items-center justify-between md:w-[30rem] p-2 md:p-4 border border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-gray-200">
      <FaSearch className="mr-2" size={18} />
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search for a recipe"
        className="flex-1 text-sm sm:text-md outline-none h-full text-neutral-700 placeholder:text-gray-500"
      />
      {query.length > 0 && <IoMdClose size={22} onClick={handleClear} />}
    </div>
  );
};

export default memo(SearchBar);
